import { useEffect, useState } from "react";
import { storage } from "@/lib/storage";

export const useTheme = () => {
  const [theme, setThemeState] = useState(() => storage.getTheme());

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    storage.setTheme(theme);
  }, [theme]);

  return {
    theme,
    toggle: () => setThemeState((t) => (t === "dark" ? "light" : "dark")),
    setTheme: setThemeState,
  };
};
